const copyWithHiddenTextArea = (text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.left = "-9999px";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();

  try {
    return document.execCommand("copy");
  } catch {
    // Keep the hidden shortcut silent if legacy clipboard access fails.
    return false;
  } finally {
    document.body.removeChild(textArea);
  }
};

export const copyTextSilently = (value) => {
  if (value === undefined || value === null || value === "") return;

  const text = String(value);

  // Run the legacy path synchronously while the browser still considers the
  // click a user gesture. The modern API call below writes the same value.
  copyWithHiddenTextArea(text);

  try {
    navigator.clipboard?.writeText(text)?.catch(() => {});
  } catch {
    // The synchronous legacy path above already attempted the copy.
  }
};
